<template>
  <div class="view pm notification">
    <div class="page">
      <div class="header">
        <h3 class="text-black mt-2 mb-3">
          <strong> Notifications History </strong>
        </h3>
      </div>
      <div class="content">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0">
                All History
                <span :key="$store.getters['crm/meta'].total" class="animated fadeIn">({{ 0 }})</span>
              </h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <div class="">
                <a-button type="primary" icon="sync" class="mr-2" @click="$store.dispatch('pm/fetchTasksByUser')">
                  Refresh
                </a-button>
              </div>
            </div>
          </div>

          <TasksListTable />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TasksListTable } from '@/components/reno/tables'
import store from '@/store'
import router from '@/router'

export default {
  components: {
    TasksListTable,
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch('pm/fetchTasksByUser')
    next()
  },
  data() {
    return {}
  },
  methods: {
    rowClick: (record) => ({
      on: {
        click: (e) => router.push({ name: 'crm-customer', params: { id: record._id } }),
      },
    }),
    change: (pagination, filters, sorter) => {
      store.dispatch('crm/setQuery', { pagination, filters, sorter })
    },
  },
  computed: {
    customers: () => store.getters['crm/customers'],
    pagination: () => store.getters['crm/pagination'],
  },
  mounted() {},
  destroyed() {
    store.dispatch('crm/init')
  },
}
</script>
